import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useTranslation } from "../i18n";
import { useDefaultValue } from "../form";
import { useConfig } from "../_util/config-context";
function groupBy(options) {
    var groups = [];
    options.forEach(function (opt, index) {
        var groupKey = opt.groupKey;
        if (index === 0 || groupKey !== options[index - 1].groupKey) {
            groups.push([]);
        }
        groups[groups.length - 1].push(opt);
    });
    return groups;
}
/**
 * 原生 Select
 */
export var NativeSelect = React.forwardRef(function NativeSelect(props, ref) {
    var _a;
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    var _b = useDefaultValue(props, null), type = _b.type, value = _b.value, onChange = _b.onChange, _c = _b.options, options = _c === void 0 ? [] : _c, _d = _b.groups, groups = _d === void 0 ? {} : _d, _e = _b.placeholder, placeholder = _e === void 0 ? t.pleaseSelect : _e, disabled = _b.disabled, size = _b.size, className = _b.className, extraProps = __rest(_b, ["type", "value", "onChange", "options", "groups", "placeholder", "disabled", "size", "className"]);
    return (React.createElement("select", __assign({ ref: ref, className: classNames(classPrefix + "-select", className, (_a = {},
            _a["size-" + (size === "full" || size === "auto" ? size + "-width" : size)] = size,
            _a)), disabled: disabled, value: value != null ? value : "", placeholder: placeholder, onChange: disabled
            ? null
            : function (event) {
                var value = event.target.value;
                onChange(value, {
                    event: event,
                    option: options.find(function (i) { return i.value === value; }),
                });
            } }, extraProps),
        typeof placeholder === "string" && (React.createElement("option", { disabled: !!value, hidden: true }, placeholder)),
        options.find(function (opt) { return !!opt.groupKey; })
            ? groupBy(options).map(function (group) {
                var _a = group[0], value = _a.value, groupKey = _a.groupKey;
                if (!groupKey) {
                    return group.map(function (opt) { return (React.createElement("option", { key: opt.value, value: opt.value, disabled: opt.disabled, title: typeof opt.tooltip === "string" ? opt.tooltip : undefined }, typeof opt.text === "undefined" ? opt.value : opt.text)); });
                }
                return (React.createElement("optgroup", { key: value, label: groups[groupKey] || "" }, group.map(function (opt) { return (React.createElement("option", { key: opt.value, value: opt.value, disabled: opt.disabled, title: typeof opt.tooltip === "string" ? opt.tooltip : undefined }, typeof opt.text === "undefined" ? opt.value : opt.text)); })));
            })
            : options.map(function (opt) { return (React.createElement("option", { key: opt.value, value: opt.value, disabled: opt.disabled, title: typeof opt.tooltip === "string" ? opt.tooltip : undefined }, typeof opt.text === "undefined" ? opt.value : opt.text)); })));
});
NativeSelect.displayName = "NativeSelect";
